import { Applicant } from '../applicant';
import { ApplicantDocument } from '../applicantDocument';


export class ApplicantDocumentSerializer {
    fromJson(json: any): ApplicantDocument {
   const data = new ApplicantDocument();
        data.id = json.id;
        data.applicant=json.applicant;
        data.file= json.file;
        return data;
    
    }

    toJson(data: ApplicantDocument): any {
        return {
            id: data.id,
            applicant :data.applicant,
            file : data.file
           // name: data.name
        };
    }
}